import type { Raster } from '@repo/warp-engine';

/** 이웃 좌표를 원본 안으로 클램프해 premultiplied 로 읽는다(가장자리 연장). */
export const samplePremul = (src: Raster, x: number, y: number, out: Float64Array): void => {
  const cx = Math.min(src.width - 1, Math.max(0, x));
  const cy = Math.min(src.height - 1, Math.max(0, y));
  const o = (cy * src.width + cx) * 4;
  const a = (src.data[o + 3] ?? 0) / 255;
  out[0] = (src.data[o] ?? 0) * a;
  out[1] = (src.data[o + 1] ?? 0) * a;
  out[2] = (src.data[o + 2] ?? 0) * a;
  out[3] = a;
};
